import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChartCompare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconChartCompare"><Path d="M5 19H21V21H3V3H5V19Z" fill="currentColor"/><Path d="M9 18H7V11H9V18Z" fill="currentColor"/><Path d="M12 18H10V7H12V18Z" fill="currentColor"/><Path d="M17 18H15V9H17V18Z" fill="currentColor"/><Path d="M20 18H18V5H20V18Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChartCompare;
